var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.link)?_c('button',{class:_vm.mode},[_vm._t("default")],2):_c('router-link',{staticClass:"mode",attrs:{"to":_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }